/* eslint-disable no-param-reassign */
import { quoteAPI } from "../api";

// eslint-disable-next-line import/prefer-default-export
export const getSettings = () => async (dispatch) => {
  return (
    quoteAPI
      .get(`settings`)
      .then(({ data }) =>
        dispatch({ type: "SET_SETTINGS", settings: { ...data } })
      )
      // if an error occurs, we'll use default settings.
      // the error will be caught by the getEstimate validation,
      // so we don't need to communicate anything to the user at this point
      // eslint-disable-next-line no-console
      .catch((e) => console.error(e))
  );
};
